import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomTooltip from '../../../../../../Components/Tooltip/CustomTooltip';
import { SaveIcon, ClearHighlightsIcon, ShowGradingsIcon } from '../../../../../../bombiix-icon';
import { useMeasurementsDispatch, useMeasurementsState } from './MeasurementsProvider';

/** Glyph size (px) inside each 28px icon button — centred with ~4.9px inset per the BM-9210 spec. */
const FLOATING_ICON_SIZE = 32;

interface MeasurementsFloatingActionsProps {
  onSave: () => void;
  onClearHighlights: () => void;
}

/**
 * Floating actions pill: Save-all (#1), Clear-highlights (#2), Show-grading (#3). BM-9210. Push is not
 * here — it lives in the Spec Table column-group header, where the columns it copies are (see
 * `cells/PushHeaderAction`). All glyphs are bombiix-icon TSX SVG components, tinted white via
 * `currentColor` from the pill's button colour.
 */
const MeasurementsFloatingActions: React.FC<MeasurementsFloatingActionsProps> = ({ onSave, onClearHighlights }) => {
  const { t } = useTranslation('bulk-edit');
  const state = useMeasurementsState();
  const dispatch = useMeasurementsDispatch();

  return (
    <div className="floting-actions bulk-measure-floating">
      <CustomTooltip placement="top" tooltipText={t('MEASUREMENTS_MODULE.SAVE_ALL')}>
        <button className="btn p-0" type="button" aria-label={t('MEASUREMENTS_MODULE.SAVE_ALL')} disabled={!state.dirty} onClick={onSave}>
          <SaveIcon  size={FLOATING_ICON_SIZE} />
        </button>
      </CustomTooltip>
      <CustomTooltip placement="top" tooltipText={t('MEASUREMENTS_MODULE.CLEAR_HIGHLIGHT')}>
        <button
          className={state.highlightActive ? 'btn p-0 btn-amber' : 'btn p-0'}
          type="button"
          aria-label={t('MEASUREMENTS_MODULE.CLEAR_HIGHLIGHT')}
          disabled={!state.highlightActive}
          onClick={onClearHighlights}
        >
          <ClearHighlightsIcon size={FLOATING_ICON_SIZE} />
        </button>
      </CustomTooltip>
      <CustomTooltip placement="top" tooltipText={t('MEASUREMENTS_MODULE.SHOW_GRADING')}>
        <button className="btn p-0" type="button" aria-label={t('MEASUREMENTS_MODULE.SHOW_GRADING')} onClick={() => dispatch({ type: 'TOGGLE_GRADING' })}>
          <ShowGradingsIcon size={FLOATING_ICON_SIZE} />
        </button>
      </CustomTooltip>
    </div>
  );
};

export default MeasurementsFloatingActions;
